
import Vue from "vue";
import { isFaIcon, faIconName } from "@/utils/drawer-links/icon-utils";

export default Vue.extend({
	props: {
		icon: {
			type: String,
			default: ""
		}
	},
	computed: {
		isFa(): boolean {
			return isFaIcon(this.icon);
		},
		faName(): string {
			return faIconName(this.icon);
		}
	}
});
